module.exports = __webpack_public_path__ + "media/images/puerta-colgante-8f8b679e816add7245fed45366558cd8.png";